import React from 'react'
import HeroBanner from '../component/Common Banner Component/HeroBanner'
import Footer from '../component/Footer/Footer';
import Helmet from "react-helmet"
import Header from '../component/Header/Header';

function ThankYou() {
    let heading = "Thank you for reaching out";
    let message = "we’ve received your message. We’ll review the details and get back to you shortly to discuss how we can best support your needs.";

    
  return (
    <>
    <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>

      <Header
          darkBg={true}
      />
      
       <div className='container py-5 my-5'>
        <div className='text-center my-5 py-5'>
          <h3 className='body-heading'>{heading}</h3>
          <p>{message}</p>
        </div>

       </div>
        <Footer
            newsletterSection={false}
        />
    </>
  )
}

export default ThankYou